import { Component, OnInit } from '@angular/core';
import { Http } from '@angular/http';
import { ActivatedRoute } from '@angular/router';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-customer-no-contract-report',
  templateUrl: './customer-no-contract-report.component.html',
  styleUrls: ['../customer-active-inactive-report/customer-active-inactive-report.component.scss']
})
export class CustomerNoContractReportComponent implements OnInit {
  loading: boolean = true;
  orgId: any;
  userId: any;
  p: number = 1;
  search: any;
  selectedCustomerDetails: any;
  allRows: any[] = [];
  filteredRows: any[] = [];

  constructor(private http: Http, private route: ActivatedRoute) { }

  ngOnInit() {
    if (this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null) {
      window.location.href = 'https://still.alshirawi.com/highmessaging/';
      return;
    }
    this.orgId = this.route.params['value'].orgId;
    this.userId = this.route.params['value'].userId;
    this.loadReport();
  }

  loadReport() {
    this.loading = true;
    const reportObj = {
      orgId: this.orgId
    };
    return this.http.post('/api/getCustomerNoContractReport', reportObj).subscribe(
      (res: any) => {
        const response = res.json() || [];
        this.allRows = response;
        this.filteredRows = this.allRows.slice();
        this.p = 1;
        this.loading = false;
      },
      () => {
        this.loading = false;
        alert('unable to load customer no contract report');
      }
    );
  }

  exportToExcel() {
    if (this.filteredRows.length <= 0) {
      alert('no records available to export');
      return;
    }
    let data = [];
    let title = 'Customer No Contract Report.xlsx';
    data.push(['Customer No Contract Report']);
    data.push([]);
    data.push(['S NO', 'CUSTOMER NAME', 'PHONE NUMBER', 'LANDLINE NUMBER', 'CONTACT NAME', 'DEPARTMENT', 'CONTACT NUMBER', 'EMAIL']);
    for (let index = 0; index < this.filteredRows.length; index++) {
      const row = this.filteredRows[index];
      data.push([
        index + 1,
        row.customer_Name,
        row.phone_Number,
        row.landline_Number,
        row.ContactName,
        row.Department,
        row.ContactNumber,
        row.Email
      ]);
    }
    let wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Customer No Contract');
    XLSX.writeFile(wb, title);
  }

  openCustomerDetails(row: any) {
    this.selectedCustomerDetails = row;
  }

  closeCustomerDetails() {
    this.selectedCustomerDetails = null;
  }
}


// WEBPACK FOOTER //
// ./client/app/customer-no-contract-report/customer-no-contract-report.component.ts